// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"ae860dd8","182":"327726ab","532":"e2285017","551":"9fdf965f","607":"4ae8c36c","787":"c2532d7b","816":"5a66b218","908":"024cef23"}[chunkId] + ".chunk.js";
};